/**
 * Service API pour la réorganisation des heats selon le classement
 */

const API_URL = process.env.REACT_APP_API_URL || 'https://events.logfit.eu/api/v1';

export interface ReseedResponse {
  success: boolean;
  target_date: string;
  reseeded_heats: number;
  teams_reassigned: number;
}

/** Périmètre optionnel : absent = toute la journée (comportement d'origine). */
export interface ReseedScope {
  wod_ids?: string[];
  category_ids?: string[];
  category_group_ids?: string[];
}

class HeatsReseedService {
  /**
   * Réorganiser les heats d'une date donnée selon le classement général
   * @param eventId ID de l'événement
   * @param targetDate Date à réorganiser (format YYYY-MM-DD)
   */
  async reseedHeats(eventId: string, targetDate: string, scope: ReseedScope = {}): Promise<ReseedResponse> {
    const response = await fetch(
      `${API_URL}/events/${eventId}/heats/reseed`,
      {
        method: 'POST',
        credentials: 'include',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ target_date: targetDate, ...scope })
      }
    );

    if (!response.ok) {
      const error = await response.json().catch(() => ({}));
      throw new Error(error.detail || `Erreur ${response.status}: ${response.statusText}`);
    }

    return response.json();
  }
}

export const heatsReseedService = new HeatsReseedService();
